export default __webpack_public_path__ + "static/media/Chalten.5330e580.jpg";